/* eslint-disable camelcase */
import TooltipInfo from "components/Common/Tooltip/Info";
import { DetectionIcon } from "mixins/svgIcons";
import React from "react";
import { connect } from "react-redux";
import { getUserCurrentJob } from "store/modules/jobs/selectors";
import "./styles.scss";
import { AIDetectionStatusConfig } from "types/common.ts";
import { SUMMARY_STATUS } from "types/store/summaries.ts";
import { getCurrentUser } from "store/modules/users/selectors";
import { useTranslation } from "react-i18next";
import { history } from "store";
import { getIsTrialOrFree } from "store/modules/notifications/selectors";


const CandidateAIDetectionPill = ({
  status,
  status_reason,
  isTranscriptionDisabled,
  role,
  isFree
}: {
    status: string;
    status_reason: string;
    isTranscriptionDisabled: boolean;
    role: string;
    isFree: boolean;
}) => {
  const { t } = useTranslation();
  const config = AIDetectionStatusConfig[status as keyof typeof AIDetectionStatusConfig] || {
    backgroundColor: "",
    textColor: "",
    iconColor: ""
  };

  const isAdmin = role === "admin";

  const handleBeacon = () => {
    const message = {
      subject: t("upsell.beacon.subject"),
      text: t("upsell.beacon.subject")
    };

    if (window.Beacon) {
      window.Beacon("open");
      window.Beacon("navigate", "/ask/message/");
      window.Beacon("prefill", message);
    }
  };

  const handleUpgrade = () => {
    if (!isAdmin) {
      handleBeacon();
      return;
    }

    if (isAdmin && !isFree) {
      handleBeacon();
      return;
    }

    history.push("/plans");
  };

  if (isTranscriptionDisabled) {
    return (
      <div className="flex flex-col items-end" style={{ marginTop: "1px" }}>
        <TooltipInfo message={t("aiDetection.tooltip")} position="bottom">
          <div className="unlock-insights-button" onClick={handleUpgrade} role="button" tabIndex={0} onKeyDown={handleUpgrade}>
            <div className="inner">
              <DetectionIcon color="#5a2af1" />
              <div className="text">
                {t("aiDetection.upgrade")}
              </div>
            </div>
          </div>
        </TooltipInfo>
      </div>
    );
  }
  return (
    <TooltipInfo message={status_reason} position="bottom">
      <div
        className={`${`bg-${config.backgroundColor} py-1 `} w-fit text-sm font-medium text-${config.textColor} flex flex-row gap-2`}
        style={{
          borderRadius: 8,
          paddingLeft: 12,
          paddingRight: 12
        }}
      >
        <DetectionIcon color={config.iconColor} />
        {status}
      </div>
    </TooltipInfo>
  );
};

const mapStateToProps = (state: any) => ({
  status: getUserCurrentJob(state)?.ai_detection?.status,
  status_reason: getUserCurrentJob(state)?.ai_detection?.status_reason,
  isTranscriptionDisabled: [SUMMARY_STATUS.DISABLED, SUMMARY_STATUS.ENABLED].includes(
    getCurrentUser(state)?.answers_transcripts_status
  ),
  role: state?.users?.currentUser?.role,
  isFree: getIsTrialOrFree(state)
});

export default connect(mapStateToProps)(CandidateAIDetectionPill);
